import React from 'react';
import ContragentRep from '../../components/reports/contragent/ContragentRep'

function ContragentRepPage(props) {
    
    
    return (
        <>
            <ContragentRep/>
        </>
    );
}

export default ContragentRepPage;